/* VELMAR PARIS — comportements vk-* : hauteur d'en-tête, textes repliables,
   tiroir de filtres (compteur en direct), « Afficher plus », vue en grille. 22/10/2026. */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  function store(k, v) {
    try { if (v === undefined) return window.localStorage.getItem(k); window.localStorage.setItem(k, v); } catch (e) { return null; }
    return null;
  }

  /* Hauteur réelle de l'en-tête (bandeau + menu) pour les bannières « plein écran » */
  function headerHeight() {
    var h = 0;
    Array.prototype.forEach.call(document.querySelectorAll('.shopify-section-group-header-group'), function (s) {
      var st = getComputedStyle(s);
      if (st.position !== 'fixed' && st.display !== 'none') h += s.getBoundingClientRect().height;
    });
    document.documentElement.style.setProperty('--vk-header-h', Math.round(h) + 'px');
  }

  /* Texte repliable sur 3 lignes */
  function initClamp(root) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-vk-clamp]'), function (el) {
      if (el.dataset.vkInit) return;
      el.dataset.vkInit = '1';
      var btn = el.parentNode.querySelector('[data-vk-clamp-toggle]');
      el.classList.add('is-clamped');
      if (!btn) return;
      if (el.scrollHeight <= el.clientHeight + 4) {
        el.classList.remove('is-clamped');
        btn.hidden = true;
        return;
      }
      btn.hidden = false;
      btn.addEventListener('click', function () {
        var open = el.classList.toggle('is-clamped') === false;
        btn.textContent = open ? btn.dataset.less : btn.dataset.more;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* Page collection */
  function initCollection(root) {
    if (root.dataset.vkInit) return;
    root.dataset.vkInit = '1';
    var sectionId = root.dataset.sectionId;
    var drawer = root.querySelector('[data-vk-drawer]');
    var form = root.querySelector('[data-vk-form]');
    var submit = root.querySelector('[data-vk-submit]');
    var lastFocus = null;

    function open() {
      if (!drawer) return;
      lastFocus = document.activeElement;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('vk-lock');
      var c = drawer.querySelector('[data-vk-close]');
      if (c) c.focus();
    }
    function close() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('vk-lock');
      if (lastFocus) lastFocus.focus();
    }
    Array.prototype.forEach.call(root.querySelectorAll('[data-vk-open]'), function (b) { b.addEventListener('click', open); });
    Array.prototype.forEach.call(root.querySelectorAll('[data-vk-close]'), function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) close(); });

    function formUrl() {
      var fd = new FormData(form);
      var p = new URLSearchParams();
      fd.forEach(function (v, k) { if (v !== '') p.append(k, v); });
      var q = p.toString();
      return form.getAttribute('action') + (q ? '?' + q : '');
    }
    var timer = null, seq = 0;
    function refreshCount() {
      if (!submit || !sectionId) return;
      clearTimeout(timer);
      timer = setTimeout(function () {
        var my = ++seq;
        var url = formUrl();
        submit.disabled = true;
        fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sectionId), { credentials: 'same-origin' })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            if (my !== seq) return;
            var m = html.match(/data-vk-count="(\d+)"/);
            if (m) submit.textContent = submit.dataset.label.replace('[n]', m[1]);
            submit.disabled = m && m[1] === '0';
          })
          .catch(function () { submit.disabled = false; });
      }, 250);
    }
    if (form) {
      form.addEventListener('change', refreshCount);
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        window.location.href = formUrl();
      });
    }

    /* Vue 2 / 4 colonnes (ordinateur) et 1 / 2 colonnes (mobile) */
    var grid = root.querySelector('[data-vk-grid]');
    function setView(n, save) {
      if (!grid) return;
      grid.classList.toggle('vk-grid--2', n === '2');
      grid.classList.toggle('vk-grid--1', n === '1');
      Array.prototype.forEach.call(root.querySelectorAll('[data-vk-view]'), function (b) {
        b.setAttribute('aria-pressed', b.dataset.vkView === n ? 'true' : 'false');
      });
      if (save) store('vk-view', n);
    }
    Array.prototype.forEach.call(root.querySelectorAll('[data-vk-view]'), function (b) {
      b.addEventListener('click', function () { setView(b.dataset.vkView, true); });
    });
    var saved = store('vk-view');
    if (saved) setView(saved, false);

    /* Afficher plus de produits */
    var more = root.querySelector('[data-vk-more]');
    function bindMore(btn) {
      if (!btn) return;
      btn.addEventListener('click', function (e) {
        var href = btn.getAttribute('href');
        if (!href || !sectionId || !grid) return;
        e.preventDefault();
        btn.setAttribute('aria-busy', 'true');
        fetch(href + (href.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sectionId), { credentials: 'same-origin' })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var g = doc.querySelector('[data-vk-grid]');
            if (g) Array.prototype.forEach.call(g.children, function (c) { grid.appendChild(document.importNode(c, true)); });
            var nm = doc.querySelector('[data-vk-more-wrap]');
            var cur = root.querySelector('[data-vk-more-wrap]');
            if (cur && nm) {
              cur.replaceWith(document.importNode(nm, true));
              bindMore(root.querySelector('[data-vk-more]'));
            } else if (cur) {
              cur.remove();
            }
          })
          .catch(function () { window.location.href = href; });
      });
    }
    bindMore(more);
  }

  function init() {
    headerHeight();
    initClamp(document);
    Array.prototype.forEach.call(document.querySelectorAll('[data-vk-coll]'), initCollection);
  }
  ready(init);
  window.addEventListener('load', headerHeight);
  window.addEventListener('resize', function () { window.requestAnimationFrame(headerHeight); });
  document.addEventListener('shopify:section:load', init);
})();
